import { render, staticRenderFns } from "./VacunaDosisNino.vue?vue&type=template&id=e54f6f10&scoped=true"
import script from "./VacunaDosisNino.vue?vue&type=script&lang=js"
export * from "./VacunaDosisNino.vue?vue&type=script&lang=js"
import style0 from "./VacunaDosisNino.vue?vue&type=style&index=0&id=e54f6f10&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e54f6f10",
  null
  
)

export default component.exports